/** When the campaign runs, picked on Eastern time. */
import type { DateKey } from '../../../shared/date-time-range/date-keys';
import type { DateTimeRange } from '../../../shared/date-time-range/date-time-range';
import { DateTimeRangePicker } from '../../../shared/date-time-range/DateTimeRangePicker';
import { EditorFieldError } from '../../shared/editor-page/EditorFieldError';
import { EditorFormSection } from '../../shared/editor-page/EditorFormSection';

export interface CampaignScheduleSectionProps {
  value: DateTimeRange;
  today: DateKey;
  /** A schedule problem the picker cannot see itself, such as one the API reported. */
  error?: string;
  /** Whether the end is after the start as real Eastern instants. */
  inOrder: boolean;
  onChange: (schedule: DateTimeRange) => void;
}

export function CampaignScheduleSection(p: CampaignScheduleSectionProps) {
  return (
    <EditorFormSection
      title="Schedule"
      titleId="campaign-schedule-title"
      hint="The discount appears when the campaign starts and disappears when it ends. All times Eastern."
      last
    >
      <DateTimeRangePicker
        value={p.value}
        inOrder={p.inOrder}
        onChange={p.onChange}
        today={p.today}
        noun="campaign"
        zoneNote="Eastern time"
      />
      {p.error && <EditorFieldError id="campaign-schedule-error">{p.error}</EditorFieldError>}
    </EditorFormSection>
  );
}
